import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DesktopIcon from "@material-ui/icons/LaptopMac";
import MobileIcon from "@material-ui/icons/PhoneIphone";
import payrollIcon from "Assets/newicons/app/payroll/outline/payroll-outline-16px.svg";
import RequestCenterIcon from "Assets/newicons/app/request-center/outline/request-center-outline-16px.svg";
import emailIcon from "Assets/newicons/user-interface/mail/outline/mail-outline-16px.svg";
import reminderIcon from "Assets/newicons/user-interface/notification-bell/outline/notification-bell-outline-16px.svg";
import userIcon from "Assets/newicons/user/user/outline/user-outline-16px.svg";
import resetIcon from "Assets/newicons/action/reset/outline/reset-outline-16px.svg";

import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import CallOutNew from "Component/Headers/callOutNew";
import PageHeader from "Component/Headers/pageHeader";
import { ErrorMessages } from "Constants";
import headersList from "Constants/headersList";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import stopIcon from "Assets/newicons/user-interface/stop/other-web (1)/icon/user-interface/stop/glyph/stop-glyph-16px-1.svg";

import { instance } from "../../../Actions/AxiosInstance";
import {
  SetAllApps,
  SetDrawerID,
  SetOpenLeftDrawer,
  SetSelection,
} from "../../../Actions/commonAction";
import { FEATUREKEYS } from "../../../Constants";
import "./notification.scss";
import { CheckActionPermission } from "Actions/commonAction";


class NotificationSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      digestdata: [],
      sidecardActive: false,
      selectedItem: [],
      masterprofileid: null,
      notificationdata: [],
      companynotificationdata: [],
      notificationtosend: [],
      entityData: [],
      companyEntityData: [],
      tempentityid: null,
      subentity: [],
      tempentityname: null,
      issave: false,
      dailyDigestTable: false,
      permissions: { readOnly: false, editable: false },
      // sidelist: [
      // {
      // svg: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
      // <path fill="" fillRule="evenodd" d="M2.91 0h10.24a.64.64 0 0 1 .64.64V3.2h-1.28V1.28H3.55V3.2H2.27V.64A.64.64 0 0 1 2.91 0zM1.23 4h13.54c.672 0 1.23.558 1.23 1.23v9.847a1.24 1.24 0 0 1-1.23 1.23H1.23A1.24 1.24 0 0 1 0 15.078V5.23C0 4.558.558 4 1.23 4zm1.662 1.23L8 9.007l5.108-3.775H2.892zM1.846 6.755v8.323h12.308V6.754L8 11.302 1.846 6.754z" />
      // </svg>,
      // name: "Request Center",
      // className: "side-menu-icons",
      // element: 'requestCenter',
      // id: "#Request Center",
      // },

      // {
      // svg: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
      // <path fill="" fillRule="evenodd" d="M8 .503c-4.414 0-8 3.51-8 7.83 0 4.12 3.263 7.5 7.395 7.805l.024.002c.192.013.385.022.581.022.196 0 .389-.009.58-.022l.025-.002C12.737 15.834 16 12.453 16 8.332c0-4.32-3.586-7.83-8-7.83zm0 .68c4.038 0 7.304 3.197 7.304 7.15a7.046 7.046 0 0 1-2.09 5.005c-.553-.394-1.236-.63-1.848-.84-.725-.248-1.41-.483-1.6-.893-.03-.35-.028-.623-.025-.936v-.133c.31-.288.698-.895.831-1.456.23-.12.51-.407.594-1.095a1.038 1.038 0 0 0-.196-.783c.188-.631.562-2.23-.093-3.262-.277-.436-.695-.711-1.244-.82-.308-.373-.89-.577-1.669-.577-1.183.021-2.05.376-2.576 1.053-.62.8-.737 2.01-.35 3.595-.143.177-.247.445-.204.794.085.688.364.975.594 1.095.133.561.52 1.168.83 1.456v.13c.004.314.006.588-.024.94-.19.41-.88.648-1.608.9-.608.21-1.287.445-1.839.834A7.046 7.046 0 0 1 .696 8.332C.696 4.38 3.962 1.184 8 1.184z" />
      // </svg>,
      // name: "Employee Profile",
      // className: "side-menu-icons",
      // element: 'employeedata',
      // id: "#Employee Profile",
      // },
      // {
      // svg: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
      // <path fill="" fillRule="evenodd" d="M2.667.5A.667.667 0 0 0 2 1.167V12.5H.667a.667.667 0 0 0-.667.667C0 15 1.5 16.5 3.333 16.5H12a.667.667 0 0 0 .066-.004 3.342 3.342 0 0 0 3.267-3.33v-12A.667.667 0 0 0 14.667.5h-12zm.666 1.333H14v11.334c0 1.112-.888 2-2 2s-2-.888-2-2a.667.667 0 0 0-.667-.667h-6V1.833zm2 2v1.334h1.334V3.833H5.333zm2.667 0v1.334h4V3.833H8zM5.333 6.5v1.333h1.334V6.5H5.333zM8 6.5v1.333h4V6.5H8zM5.333 9.167V10.5h1.334V9.167H5.333zm2.667 0V10.5h4V9.167H8z" />
      // </svg>,
      // name: "Policies",
      // className: "side-menu-icons",
      // element: 'Policies',
      // id: "#Policies",
      // },
      // {
      // svg: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      // <path fill="" fillRule="evenodd" d="M2.958 1.3a.615.615 0 0 0-.5.281l-.814 1.222-.085-.084a.615.615 0 1 0-.87.87l.616.615a.615.615 0 0 0 .947-.094l1.23-1.846a.615.615 0 0 0-.524-.964zm3.09 1.238a.615.615 0 1 0 0 1.231h8.615a.615.615 0 1 0 0-1.23H6.047zm-3.09 3.685a.615.615 0 0 0-.5.282l-.814 1.22-.085-.083a.615.615 0 1 0-.87.87l.616.615a.615.615 0 0 0 .947-.094l1.23-1.846a.615.615 0 0 0-.524-.964zm3.09 1.238a.615.615 0 1 0 0 1.231h8.615a.615.615 0 1 0 0-1.23H6.047zm-3.693 3.693A1.856 1.856 0 0 0 .51 13c0 1.012.834 1.846 1.846 1.846A1.856 1.856 0 0 0 4.201 13a1.856 1.856 0 0 0-1.846-1.846zm0 1.23c.347 0 .615.269.615.616a.606.606 0 0 1-.615.615A.606.606 0 0 1 1.74 13c0-.347.268-.616.615-.616zm3.692 0a.615.615 0 1 0 0 1.231h8.616a.615.615 0 1 0 0-1.23H6.047z" />
      // </svg>,
      // name: "Daily Activites",
      // className: "side-menu-icons",
      // element: 'dailyActivites',
      // id: "#Daily Activites",
      // },
      // {
      // svg: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
      // <path fill="" fillRule="evenodd" d="M1.23 0L0 1.23l1.23 2.462 1.847.616L5.23 6.462 6.46 5.23 4.309 3.077 3.692 1.23 1.231 0zM12.35.006a3.782 3.782 0 0 0-2.833 1.107C8.509 2.12 8.419 3.331 8.919 4.47l-7.147 7.148a1.845 1.845 0 1 0 2.61 2.61l7.148-7.147c1.14.5 2.35.41 3.357-.598a3.793 3.793 0 0 0 .93-3.839l-2.28 2.281-1.97-.492-.492-1.97 2.28-2.28A3.825 3.825 0 0 0 12.35.006zm-.951 9.001l-2.316 2.316 2.965 2.967a1.638 1.638 0 1 0 2.317-2.318l-2.966-2.965zm-8.321 3.3a.616.616 0 1 1 0 1.232.616.616 0 0 1 0-1.231z" />
      // </svg>,
      // name: "Configurations",
      // className: "side-menu-icons",
      // element: 'Configuration',
      // },
      // ],
      RequestCenterTable: [
        {
          headerDate: {
            headername: "Request Center",
            desktop: "Web",
            mobile: "Mobile",
            email: "Email",
          },
          tableData: [
            { name: "Attendance" },
            { name: "Leaves" },
            { name: "Employees" },
          ],
        },
      ],
      EmployeeProfileTable: [
        {
          headerDate: {
            headername: "Employee Profile",
            desktop: "Web",
            mobile: "Mobile",
            email: "Email",
          },
          tableData: [
            { name: "Probation" },
            { name: "Designation" },
            { name: "Managers (Primary & Secondary" },
            { name: "Reporting Office Location" },
            { name: "Department" },
            { name: "Team" },
            { name: "Business Unit" },
            { name: "Employment Type" },
          ],
        },
      ],
      PolicesTable: [
        {
          headerDate: {
            headername: "Policies",
            desktop: "Web",
            mobile: "Mobile",
            email: "Email",
          },
          tableData: [
            { name: "Default Permission and Policies" },
            { name: "Approval Workflow" },
            { name: "Shift" },
            { name: "Attendance Policy" },
            { name: "Clock-in Method" },
            { name: "Weekly-offs" },
            { name: "Leave Policy" },
            { name: "Extra Time Policy" },
            { name: "Holiday Plan" },
          ],
        },
      ],
      DailyActivtes: [
        {
          headerDate: {
            headername: "Daily Activities",
            desktop: "Web",
            mobile: "Mobile",
            email: "Email",
          },
          tableData: [
            { name: "Daily Digest (start off the day, other's info " },
            { name: "Daily summary (end of day , self's info)" },
            { name: "Shift begin" },
            { name: "Late for shift" },
            { name: "Extra time begin" },
            { name: "Upcoming holiday" },
            { name: "Message via directory" },
            { name: "Report Robo updates" },
          ],
        },
      ],
      activeTabValue: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.sendNotificationData = this.sendNotificationData.bind(this);
    // this.sideActive = this.sideActive(this);
    this.setEntityData = this.setEntityData.bind(this);
    this.setCompanyEntityData = this.setCompanyEntityData.bind(this);
    this.getDigestData = this.getDigestData.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
    this.sendDigestData = this.sendDigestData.bind(this);
    this.getCompanyPerferances = this.getCompanyPerferances.bind(this);
  }

  componentDidMount() {

    const [isTrue, permissions] = CheckActionPermission("notificationPreferences");

    if (isTrue) {
      this.setState({ permissions });
    }
    this.getPerferances();
    this.getDigestData();


    const masterprofileid = get(
      this.props,
      "AuthenticationAction.login.masterprofileid",
      "",
    );
    this.setState({
      masterprofileid,
    });
  }

  sideActive(e) {
    this.setState({ sidecardActive: true });
  }

  setEntityData(Data, tempIndex) {
    this.setState({
      // dropdown: false,
      // customData: Data,
      tempIndex,
      tempentityname: Data.entityname,
      tempentityid: Data.entityid,
      subentity: Data.subentityjson,
      dailyDigestTable: false,
      showDailyDigest: false
    });
  }

  setCompanyEntityData(Data, tempIndex) {
    this.setState({

      tempIndex,
      tempentityname: Data.entityname,
      tempentityid: Data.entityid,
      subentity: Data.subentityjson,
      dailyDigestTable: false,
    });
  }





  getDigestData() {
    instance.get("subscription/digestconfig").then((result) => {
      this.setState({ digestdata: result.data.result });
    });
  }

  getPerferances() {
    instance.get("subscription/notificationpreference").then((result) => {
      this.setState({ entityData: result.data.result });
    });
  }

  getCompanyPerferances() {
    instance.get("subscription/subscriptionnotificationconfig").then((result) => {
      this.setState({ companyEntityData: result.data.result, showDailyDigest: true, });
    });
  }




  updatePostData(key, value) {
    const { digestdata } = this.state;
    digestdata[0][key] = value;
    this.setState({
      digestdata,
      issave: true,
    });
  }

  sendDigestData() {
    const { digestdata } = this.state;
    const URL = "subscription/digestconfig";
    const data = {
      ismdigestallowed: digestdata[0].ismdigestallowed,
      isedigestallowed: digestdata[0].isedigestallowed,
    };
    instance
      .post(URL, data)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
      })
      .catch((error) => {
        this.setState({
          // postData: JSON.parse(Data),
        });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleTabChange = (e, activeTabValue) => {
    this.setState({
      activeTabValue, 
      companynotificationdata: [], 
      notificationdata: [], 
      subentity: [], 
      tempIndex: null,
      tempentityid: null,
      tempentityname: null,
      dailyDigestTable: false,
      showDailyDigest: false
      
    }, () => {
      activeTabValue == 1 && this.getCompanyPerferances();
    });
  };


  handleChange(e, index, subindex, key) {
    const data = [...this.state.entityData];
    const notificationdata = [...this.state.notificationdata];
    if (key == "web") {
      if (data[index].subentityjson[subindex].iswebenable == true) {
        data[index].subentityjson[subindex].iswebpreference = e.target.checked;
      } else return;
    } else if (key == "mobile") {
      if (data[index].subentityjson[subindex].ismobileenable == true) {
        data[index].subentityjson[subindex].ismobilepreference =
          e.target.checked;
      } else return;
    } else if (data[index].subentityjson[subindex].ismailenable == true) {
      data[index].subentityjson[subindex].ismailpreference = e.target.checked;
    } else return;
    // const notifIndex = notificationdata.findIndex(
    //   (x) => x.subentityid == data[index].subentityjson[subindex].subentityid,
    // );

    const notifIndex = notificationdata.findIndex(
      (x) => x.entityid == data[index].entityid && x.subentityid == data[index].subentityjson[subindex].subentityid,
    );

    console.log(
      "TCL: NotificationSettings -> handleChange -> notifIndex",
      notifIndex,
    );
    if (notifIndex != -1) {
      // already modified so replace
      notificationdata[notifIndex] = {
        entityid: data[index].entityid,
        subentityid: data[index].subentityjson[subindex].subentityid,
        emppreferenceid: data[index].subentityjson[subindex].emppreferenceid,
        notifyat: data[index].subentityjson[subindex].notifyat,
        iswebpreference: data[index].subentityjson[subindex].iswebpreference,
        ismobilepreference:
          data[index].subentityjson[subindex].ismobilepreference,
        ismailpreference: data[index].subentityjson[subindex].ismailpreference,
        isplaysound: data[index].subentityjson[subindex].isplaysound,
      };
    } else {
      // not modified so push
      notificationdata.push({
        entityid: data[index].entityid,
        subentityid: data[index].subentityjson[subindex].subentityid,
        emppreferenceid: data[index].subentityjson[subindex].emppreferenceid,
        notifyat: data[index].subentityjson[subindex].notifyat,
        iswebpreference: data[index].subentityjson[subindex].iswebpreference,
        ismobilepreference:
          data[index].subentityjson[subindex].ismobilepreference,
        ismailpreference: data[index].subentityjson[subindex].ismailpreference,
        isplaysound: data[index].subentityjson[subindex].isplaysound,
      });
    }
    this.setState({ notificationdata, entityData: data });
  }

  handleChange1(e, index, subindex, tempsubentityid) {
    console.log("index, subindex, tempentityid, tempsubentityid", index, subindex, this.state.tempentityid, tempsubentityid );
    const data = [...this.state.companyEntityData];
    const companynotificationdata = [...this.state.companynotificationdata];
    if (data[index].subentityjson[subindex].isstoppedenable == true) {
      data[index].subentityjson[subindex].isstopped = e.target.checked;
    } else return;
    
    const notifIndex = companynotificationdata.findIndex(
      (x) => x.entityid == data[index].entityid && x.subentityid == data[index].subentityjson[subindex].subentityid,
    );

    console.log("notifIndex", notifIndex);
   
    if (notifIndex != -1) {
      // already modified so replace
      companynotificationdata[notifIndex] = {
        entityid: data[index].entityid,
        subentityid: data[index].subentityjson[subindex].subentityid,
        subscriptionnotificationconfigid: data[index].subentityjson[subindex].subscriptionnotificationconfigid,
        isstopped: data[index].subentityjson[subindex].isstopped
      };
    } else {
      // not modified so push
      companynotificationdata.push({
        entityid: data[index].entityid,
        subentityid: data[index].subentityjson[subindex].subentityid,
        subscriptionnotificationconfigid: data[index].subentityjson[subindex].subscriptionnotificationconfigid,
        isstopped: data[index].subentityjson[subindex].isstopped
      });
    }

   

    
    this.setState({ companynotificationdata, companyEntityData: data });
  }

  sendNotificationData() {
    const data = {
      notification: [...this.state.notificationdata],
    };
    const URL = "subscription/notificationpreference";
    instance
      .post(URL, data)
      .then((result) => {
        this.props.enqueueSnackbar("Preferences Updated successfully", {
          variant: "success",
        });
        this.setState({ notificationdata: [] }, () => this.getPerferances())
      })
      .catch((result) => {
        this.props.enqueueSnackbar(
          "Something Went Wrong",
          `${result.errormsg}`,
          { variant: "Waring" },
        );
      });
  }

  sendCompanyNotificationData() {
    const data = {
      notification: [...this.state.companynotificationdata],
    };
    const URL = "subscription/subscriptionnotificationconfig";
    instance
      .post(URL, data)
      .then((result) => {
        this.props.enqueueSnackbar("Updated successfully", {
          variant: "success",
        });
        this.setState({ companynotificationdata: [] }, () => this.getCompanyPerferances())

      })
      .catch((result) => {
        this.props.enqueueSnackbar(
          "Something Went Wrong",
          `${result.errormsg}`,
          { variant: "Waring" },
        );
      });
  }

  render() {
    const { digestdata, activeTabValue } = this.state;
    const { masterprofileid } = this.state;

    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.NotificationPreferences.header}</title>
        </Helmet>

        {/* <PageHeader header="Your Notification Preferences" /> */}

        <Tabs
          value={activeTabValue}
          onChange={this.handleTabChange.bind(this)}
          indicatorColor="#fff"
          textColor="primary"
        >
          <Tab
            label={

              <span>
                Your Notification Preferences
              </span>
            }
            className={`tabheading ${activeTabValue == 0 ? "active-tab1" : "inactive-tab1"
              } `}
            style={{ maxWidth: "unset" }}
          />
          {masterprofileid == 9 &&
            <Tab
              label={

                <span>
                  Company Notification Preferences
                </span>
              }
              className={`tabheading ${activeTabValue == 1 ? "active-tab1" : "inactive-tab1"
                } `}
              style={{ maxWidth: "unset" }}
            />
          }
        </Tabs>
        <div className="tab-border" />
        <div style={{ marginTop: 32 }}>

          {activeTabValue == 0 &&

            <Grid container spacing={2}>
              <Grid item md={5} sm={12}>
                <Paper className="side-card">
                  <List component="nav" style={{ paddingTop: 0, paddingBottom: 0 }}>
                    {this.state.entityData.map((item, index) => (

                      <ListItem
                        button
                        className={
                          this.state.tempIndex == index
                            ? "list-item-active"
                            : "list-item"
                        }

                        onClick={() => this.setEntityData(item, index)}
                      >
                        <ListItemIcon className="side-menu-icons">
                          {/* {item.svg} */}
                          {item.entityid == 1 ? (
                            <img src={RequestCenterIcon}></img>
                          ) : item.entityid == 2 ? (
                            <img src={userIcon}></img>
                          ) : item.entityid == 3 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                            >
                              <path
                                fill=""
                                fillRule="evenodd"
                                d="M2.667.5A.667.667 0 0 0 2 1.167V12.5H.667a.667.667 0 0 0-.667.667C0 15 1.5 16.5 3.333 16.5H12a.667.667 0 0 0 .066-.004 3.342 3.342 0 0 0 3.267-3.33v-12A.667.667 0 0 0 14.667.5h-12zm.666 1.333H14v11.334c0 1.112-.888 2-2 2s-2-.888-2-2a.667.667 0 0 0-.667-.667h-6V1.833zm2 2v1.334h1.334V3.833H5.333zm2.667 0v1.334h4V3.833H8zM5.333 6.5v1.333h1.334V6.5H5.333zM8 6.5v1.333h4V6.5H8zM5.333 9.167V10.5h1.334V9.167H5.333zm2.667 0V10.5h4V9.167H8z"
                              />
                            </svg>
                          ) : item.entityid == 4 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill=""
                                fillRule="evenodd"
                                d="M2.958 1.3a.615.615 0 0 0-.5.281l-.814 1.222-.085-.084a.615.615 0 1 0-.87.87l.616.615a.615.615 0 0 0 .947-.094l1.23-1.846a.615.615 0 0 0-.524-.964zm3.09 1.238a.615.615 0 1 0 0 1.231h8.615a.615.615 0 1 0 0-1.23H6.047zm-3.09 3.685a.615.615 0 0 0-.5.282l-.814 1.22-.085-.083a.615.615 0 1 0-.87.87l.616.615a.615.615 0 0 0 .947-.094l1.23-1.846a.615.615 0 0 0-.524-.964zm3.09 1.238a.615.615 0 1 0 0 1.231h8.615a.615.615 0 1 0 0-1.23H6.047zm-3.693 3.693A1.856 1.856 0 0 0 .51 13c0 1.012.834 1.846 1.846 1.846A1.856 1.856 0 0 0 4.201 13a1.856 1.856 0 0 0-1.846-1.846zm0 1.23c.347 0 .615.269.615.616a.606.606 0 0 1-.615.615A.606.606 0 0 1 1.74 13c0-.347.268-.616.615-.616zm3.692 0a.615.615 0 1 0 0 1.231h8.616a.615.615 0 1 0 0-1.23H6.047z"
                              />
                            </svg>
                          ) : item.entityid == 5 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="15"
                              viewBox="0 0 16 15"
                            >
                              <path
                                fill=""
                                fillRule="evenodd"
                                d="M1.23 0L0 1.23l1.23 2.462 1.847.616L5.23 6.462 6.46 5.23 4.309 3.077 3.692 1.23 1.231 0zM12.35.006a3.782 3.782 0 0 0-2.833 1.107C8.509 2.12 8.419 3.331 8.919 4.47l-7.147 7.148a1.845 1.845 0 1 0 2.61 2.61l7.148-7.147c1.14.5 2.35.41 3.357-.598a3.793 3.793 0 0 0 .93-3.839l-2.28 2.281-1.97-.492-.492-1.97 2.28-2.28A3.825 3.825 0 0 0 12.35.006zm-.951 9.001l-2.316 2.316 2.965 2.967a1.638 1.638 0 1 0 2.317-2.318l-2.966-2.965zm-8.321 3.3a.616.616 0 1 1 0 1.232.616.616 0 0 1 0-1.231z"
                              />
                            </svg>
                          ) : item.entityid == 10 ? (
                            <img src={reminderIcon}></img>
                          ) : item.entityid == 11 ? (
                            <img src={payrollIcon}></img>
                          ) : item.entityid == 12 ? (
                            <img src={resetIcon}></img>
                          ) : (
                            ""
                          )}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.entityname}
                          style={{ fontSize: 14 }}
                        />
                      </ListItem>

                    ))}

                    {/* {masterprofileid == 9 && ( */}
                    {/* <ListItem
                  button
                  className="list-item"
                  onClick={() =>
                    this.setState({
                      dailyDigestTable: true,
                      tempIndex: null,
                      tempentityid: null,
                      tempentityname: null,

                      subentity: [],
                    })
                  }
                  style={{ borderTop: "dashed 1px #dddd" }}
                // onBlur={() => this.setState({ dailyDigestTable: false })}
                >
                  <ListItemIcon className="side-menu-icons">
                    <img src={emailIcon}></img>
                  </ListItemIcon>
                  <ListItemText primary="Daily digest" />
                </ListItem> */}
                    {/* )} */}
                  </List>
                </Paper>
              </Grid>

              <Grid item md={7} sm={12}>
                <div
                  className="table thin-scroll"
                  style={{ height: "70vh", overflowY: "auto" }}
                >
                
                  {!this.state.dailyDigestTable && (
                    <Table
                      className="rounded-rectangle-div padding0"
                      style={{ borderRadius: 4 }}
                    >
                      {this.state.tempentityname && (
                        <TableHead className="tableheader" id="Request Center">
                          <TableRow>
                            <TableCell>
                              <span>{this.state.tempentityname}</span>
                            </TableCell>
                            <TableCell>
                              <span>
                                <DesktopIcon />
                              </span>
                              <span className="table-header-icon-lable">Web</span>
                            </TableCell>
                            <TableCell>
                              <MobileIcon />
                              <span className="table-header-icon-lable">
                                Mobile
                              </span>
                            </TableCell>
                            <TableCell>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill="#545556"
                                  fillRule="evenodd"
                                  d="M1.23 2A1.24 1.24 0 0 0 0 3.23v9.847c0 .673.558 1.23 1.23 1.23h13.54a1.24 1.24 0 0 0 1.23-1.23V3.23A1.24 1.24 0 0 0 14.77 2H1.23zm1.662 1.23h10.216L8 7.007 2.892 3.231zM1.846 4.755L8 9.302l6.154-4.548v8.323H1.846V4.754z"
                                />
                              </svg>
                              Email
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      )}
                      <TableBody>
                        {this.state.subentity &&
                          this.state.subentity.map((row, index) => (
                            //
                            <TableRow key={row}>
                              <TableCell component="th" scope="row">
                                {row.subentityname}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Checkbox
                                  color="primary"
                                  className="checkbox"
                                  checked={row.iswebenable && row.iswebpreference}
                                  // disabled={!row.iswebenable && this.state.permissions &&
                                  //   !this.state.permissions.editable}
                                  disabled={(!row.iswebenable) || (this.state.permissions &&
                                    !this.state.permissions.editable)}
                                  onChange={(e) =>
                                    this.handleChange(
                                      e,
                                      this.state.tempIndex,
                                      index,
                                      "web",
                                    )
                                  }
                                />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Checkbox
                                  onChange={(e) =>
                                    this.handleChange(
                                      e,
                                      this.state.tempIndex,
                                      index,
                                      "mobile",
                                    )
                                  }
                                  className="checkbox"
                                  checked={
                                    row.ismobileenable && row.ismobilepreference
                                  }
                                  // checked={item.ismobileenable&&item.ismobilepreference?true:false}
                                  //  disabled={!row.ismobileenable}
                                  disabled={(!row.ismobileenable) || (this.state.permissions &&
                                    !this.state.permissions.editable)}
                                  color="primary"
                                />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Checkbox
                                  onChange={(e) =>
                                    this.handleChange(
                                      e,
                                      this.state.tempIndex,
                                      index,
                                      "email",
                                    )
                                  }
                                  checked={row.ismailenable && row.ismailpreference}
                                  className="checkbox"
                                  color="primary"
                                  // checked={item.ismailenable&&item.ismailpreference?true:false}
                                  // disabled={!row.ismailenable}
                                  disabled={(!row.ismailenable) || (this.state.permissions &&
                                    !this.state.permissions.editable)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  )}
                </div>
              </Grid>

              {/* {masterprofileid == 9 && (
 <div className="margin-top-8 " style={{ display: "flex" }}>
 <span className="" style={{ marginRight: 8, width: 161 }}>
 <DynamicForm
 className="width100 floatleft"
 fields={checkboxinputconverter({
 value: digestdata[0] && digestdata[0].ismdigestallowed,
 // postData.isfromold == true,
 placeholder: "",
 label: "Morning digest ",
 })}
 onChange={(value) => {
 this.updatePostData("ismdigestallowed", value);
 }}
 />
 </span>
 <span className="" style={{ marginRight: 8, width: 161 }}>
 <DynamicForm
 className="width100 "
 fields={checkboxinputconverter({
 value: digestdata[0] && digestdata[0].isedigestallowed,
 // postData.isfromold == false,
 placeholder: "",
 label: "Evening digest",
 })}
 onChange={(value) => {
 this.updatePostData("isedigestallowed", value);
 }}
 />
 </span>
 </div>
 )} */}
            </Grid>
          }

          {activeTabValue == 1 &&

            <Grid container spacing={2}>
              <Grid item md={5} sm={12}>
                <Paper className="side-card">
                  <List component="nav" style={{ paddingTop: 0, paddingBottom: 0 }}>
                    {this.state.companyEntityData.map((item, index) => (

                      <ListItem
                        button
                        className={
                          this.state.tempIndex == index
                            ? "list-item-active"
                            : "list-item"
                        }
                        onClick={() => this.setCompanyEntityData(item, index)}
                      >
                        <ListItemIcon className="side-menu-icons">

                          {item.entityid == 1 ? (
                            <img src={RequestCenterIcon}></img>
                          ) : item.entityid == 2 ? (
                            <img src={userIcon}></img>
                          ) : item.entityid == 3 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                            >
                              <path
                                fill=""
                                fillRule="evenodd"
                                d="M2.667.5A.667.667 0 0 0 2 1.167V12.5H.667a.667.667 0 0 0-.667.667C0 15 1.5 16.5 3.333 16.5H12a.667.667 0 0 0 .066-.004 3.342 3.342 0 0 0 3.267-3.33v-12A.667.667 0 0 0 14.667.5h-12zm.666 1.333H14v11.334c0 1.112-.888 2-2 2s-2-.888-2-2a.667.667 0 0 0-.667-.667h-6V1.833zm2 2v1.334h1.334V3.833H5.333zm2.667 0v1.334h4V3.833H8zM5.333 6.5v1.333h1.334V6.5H5.333zM8 6.5v1.333h4V6.5H8zM5.333 9.167V10.5h1.334V9.167H5.333zm2.667 0V10.5h4V9.167H8z"
                              />
                            </svg>
                          ) : item.entityid == 4 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill=""
                                fillRule="evenodd"
                                d="M2.958 1.3a.615.615 0 0 0-.5.281l-.814 1.222-.085-.084a.615.615 0 1 0-.87.87l.616.615a.615.615 0 0 0 .947-.094l1.23-1.846a.615.615 0 0 0-.524-.964zm3.09 1.238a.615.615 0 1 0 0 1.231h8.615a.615.615 0 1 0 0-1.23H6.047zm-3.09 3.685a.615.615 0 0 0-.5.282l-.814 1.22-.085-.083a.615.615 0 1 0-.87.87l.616.615a.615.615 0 0 0 .947-.094l1.23-1.846a.615.615 0 0 0-.524-.964zm3.09 1.238a.615.615 0 1 0 0 1.231h8.615a.615.615 0 1 0 0-1.23H6.047zm-3.693 3.693A1.856 1.856 0 0 0 .51 13c0 1.012.834 1.846 1.846 1.846A1.856 1.856 0 0 0 4.201 13a1.856 1.856 0 0 0-1.846-1.846zm0 1.23c.347 0 .615.269.615.616a.606.606 0 0 1-.615.615A.606.606 0 0 1 1.74 13c0-.347.268-.616.615-.616zm3.692 0a.615.615 0 1 0 0 1.231h8.616a.615.615 0 1 0 0-1.23H6.047z"
                              />
                            </svg>
                          ) : item.entityid == 5 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="15"
                              viewBox="0 0 16 15"
                            >
                              <path
                                fill=""
                                fillRule="evenodd"
                                d="M1.23 0L0 1.23l1.23 2.462 1.847.616L5.23 6.462 6.46 5.23 4.309 3.077 3.692 1.23 1.231 0zM12.35.006a3.782 3.782 0 0 0-2.833 1.107C8.509 2.12 8.419 3.331 8.919 4.47l-7.147 7.148a1.845 1.845 0 1 0 2.61 2.61l7.148-7.147c1.14.5 2.35.41 3.357-.598a3.793 3.793 0 0 0 .93-3.839l-2.28 2.281-1.97-.492-.492-1.97 2.28-2.28A3.825 3.825 0 0 0 12.35.006zm-.951 9.001l-2.316 2.316 2.965 2.967a1.638 1.638 0 1 0 2.317-2.318l-2.966-2.965zm-8.321 3.3a.616.616 0 1 1 0 1.232.616.616 0 0 1 0-1.231z"
                              />
                            </svg>
                          ) : item.entityid == 10 ? (
                            <img src={reminderIcon}></img>
                          ) : item.entityid == 11 ? (
                            <img src={payrollIcon}></img>
                          ) : item.entityid == 12 ? (
                            <img src={resetIcon}></img>
                          ) : (
                            ""
                          )}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.entityname}
                          style={{ fontSize: 14 }}
                        />
                      </ListItem>

                    ))}

                 {this.state.showDailyDigest &&
                    <ListItem
                      button

                      className={
                        this.state.dailyDigestTable
                          ? "list-item-active"
                          : "list-item"
                      }
                      onClick={() =>
                        this.setState({
                          dailyDigestTable: true,
                          tempIndex: null,
                          tempentityid: null,
                          tempentityname: null,

                          subentity: [],
                        })
                      }
                      style={{ borderTop: "dashed 1px #dddd" }}

                    >
                      <ListItemIcon className="side-menu-icons">
                        <img src={emailIcon}></img>
                      </ListItemIcon>
                      <ListItemText primary="Daily digest" />
                    </ListItem>
                  }
                  </List>
                </Paper>
              </Grid>

              <Grid item md={7} sm={12}>
                <div
                  className="table thin-scroll"
                  style={{ height: "70vh", overflowY: "auto" }}
                >
                  {this.state.dailyDigestTable && (
                    <div>
                      <Table
                        className="rounded-rectangle-div padding0"
                        style={{ borderRadius: 4 }}
                      >
                        <TableHead className="tableheader" id="Daily digest">
                          <TableRow>
                            <TableCell>
                              <span>Daily digest</span>
                            </TableCell>

                            <TableCell>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill="#545556"
                                  fillRule="evenodd"
                                  d="M1.23 2A1.24 1.24 0 0 0 0 3.23v9.847c0 .673.558 1.23 1.23 1.23h13.54a1.24 1.24 0 0 0 1.23-1.23V3.23A1.24 1.24 0 0 0 14.77 2H1.23zm1.662 1.23h10.216L8 7.007 2.892 3.231zM1.846 4.755L8 9.302l6.154-4.548v8.323H1.846V4.754z"
                                />
                              </svg>
                              Email
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Morning digest
                            </TableCell>

                            <TableCell
                              component="th"
                              scope="row"
                              className="position-rel"
                            >
                              <div
                                style={{
                                  top: 14,
                                  left: 0,
                                  right: 0,
                                  margin: "auto",
                                  position: "absolute",
                                  height: 24,
                                  width: 24,
                                }}
                              >
                                <DynamicForm
                                  className="width100 floatleft"
                                  fields={checkboxinputconverter({
                                    value:
                                      digestdata[0] &&
                                      digestdata[0].ismdigestallowed,
                                    // postData.isfromold == true,
                                    placeholder: "",
                                    label: "",
                                    disabled: masterprofileid == 9 ? false : true,
                                  })}
                                  onChange={(value) => {
                                    this.updatePostData("ismdigestallowed", value);
                                  }}
                                />
                              </div>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Evening digest
                            </TableCell>

                            <TableCell
                              component="th"
                              scope="row"
                              className="position-rel"
                            >
                              <div
                                style={{
                                  top: 14,
                                  left: 0,
                                  right: 0,
                                  margin: "auto",
                                  position: "absolute",
                                  height: 24,
                                  width: 24,
                                }}
                              >
                                <DynamicForm
                                  className="width100 "
                                  fields={checkboxinputconverter({
                                    value:
                                      digestdata[0] &&
                                      digestdata[0].isedigestallowed,
                                    // postData.isfromold == false,
                                    placeholder: "",
                                    label: "",
                                    disabled: masterprofileid == 9 ? false : true,
                                  })}
                                  onChange={(value) => {
                                    this.updatePostData("isedigestallowed", value);
                                  }}
                                />
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      <div className="margin-top-24">
                        <CallOutNew
                          classnames="bg-light-blue width100"
                          header="This feature is only editable by administrators & any changes here will be applicable to all employees. For example: If the admin disable Morning Digest via Email then employees will stop receiving morning digest."
                          emoji=""
                          textcolor="#1e8ced"
                        />
                      </div>
                      <div className="margin-top-24">
                        <CallOutNew
                          classnames="bg-light-blue width100"
                          header="Daily digest will only be sent when there is at least one activity to notify you."
                          emoji=""
                          textcolor="#1e8ced"
                        />
                      </div>
                      <div className="margin-top-24">
                        <CallOutNew
                          classnames="bg-light-blue width100"
                          header={
                            <div>
                              <span>
                                Morning Digest (ETA, daily 08:00 to 10:30)
                              </span>
                              <br></br>
                              <span>
                                Evening Digest (ETA, daily 18:00 to 20:30)
                              </span>
                            </div>
                          }
                          emoji=""
                          textcolor="#1e8ced"
                        />
                      </div>
                    </div>
                  )}
                  {!this.state.dailyDigestTable && (
                    <Table
                      className="rounded-rectangle-div padding0"
                      style={{ borderRadius: 4 }}
                    >
                      {this.state.tempentityname && (
                        <TableHead className="tableheader" id="Request Center">
                          <TableRow>
                            <TableCell>
                              <span>{this.state.tempentityname}</span>
                            </TableCell>
                            <TableCell>
                              <div className="display-flex" style={{ alignItems: "center", justifyContent: "center" }}>

                                <img src={stopIcon} style={{ marginRight: 8 }}></img>

                                <span className="table-header-icon-lable">Stop notification</span>
                              </div>
                            </TableCell>


                          </TableRow>
                        </TableHead>
                      )}
                      <TableBody>
                        {this.state.subentity &&
                          this.state.subentity.map((row, index) => (
                            //
                            <TableRow key={row}>
                              <TableCell component="th" scope="row">
                                {row.subentityname}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Checkbox
                                  color="primary"
                                  className="checkbox"

                                  checked={row.isstopped}
                                  disabled={(!row.isstoppedenable) || (this.state.permissions &&
                                    !this.state.permissions.editable)}
                                  onChange={(e) =>
                                    this.handleChange1(
                                      e,
                                      this.state.tempIndex,
                                      index,
                                      row.subentityid

                                    )
                                  }
                                />
                              </TableCell>


                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  )}
                </div>
              </Grid>


            </Grid>
          }

        </div>

        <div>
          <div className="floatleft" style={{ marginLeft: 172 }}>
            <div
              className="width100"
              style={{
                position: "fixed",
                left: 0,
                background: "white",
                bottom: 0,
                padding: 10,
                borderTop: "1px solid #d4d4d4",
                zIndex: 0,
              }}
            >
              <div>
                {activeTabValue == 0 &&
                  <div className="floatright" style={{ marginRight: 72 }}>
                  
                      <div>
                        <Button
                          onClick={() => {
                            this.sendNotificationData();
                          }}
                          variant="contained"
                          className={
                            this.state.notificationdata.length > 0
                              ? "btn btn-primary-md-blue"
                              : "btn btn-primary-md-grey"
                          }
                          disabled={
                            this.state.notificationdata.length > 0 ? false : true
                          }
                        >
                          Save
                        </Button>
                      </div>
                  
                  </div>
                }
                {activeTabValue == 1 &&
                  <div className="floatright" style={{ marginRight: 72 }}>
                     {this.state.dailyDigestTable ? 
                     <Button
                        onClick={() => {
                          this.sendDigestData();
                        }}
                        variant="contained"
                        className={
                          this.state.issave
                            ? "btn btn-primary-md-blue"
                            : "btn btn-primary-md-grey"
                        }
                        disabled={
                          this.state.issave && masterprofileid == 9 ? false : true
                        }
                      >
                        Save
                      </Button>
                  :  <Button
                      onClick={() => {
                        this.sendCompanyNotificationData();
                      }}
                      variant="contained"
                      className={
                        this.state.companynotificationdata.length > 0
                          ? "btn btn-primary-md-blue"
                          : "btn btn-primary-md-grey"
                      }
                      disabled={
                        this.state.companynotificationdata.length > 0 ? false : true
                      }
                    >
                      Save
                    </Button>
                    }
                  </div>
                }
                <div className="clearfloat"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  FCMReducer: state.FCMReducer,
  SetOpenLeftDrawer: state.selectionReducer.openLeftDrawer,
  isallappsopen: state.selectionReducer.isallappsopen,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      SetOpenLeftDrawer: (type, payload) => SetOpenLeftDrawer(type, payload),
      SetAllApps,
      SetSelection: (d) => SetSelection(d),
      // updateAuthentication: data => updateAuthentication(data),
      // CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      // SetSelection: d => SetSelection(d),
      SetDrawerID: (dt) => SetDrawerID(dt),
      // updateSubscriptionInfo: (type, payload) => updateSubscriptionInfo(type, payload),
      // SetMenuList,
      // SetMenuData,
      // SetClickedBreadCrum,
      // SetOpenLeftDrawer
    },
    dispatch,
  );
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withSnackbar(NotificationSettings)),
);
